export default __webpack_public_path__ + "static/media/aggimage_10091.2bc8f693.jpg";